import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { PhosphorIcon } from 'district-ui-client/components/phosphor-icon'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type School from 'district-ui-client/models/school'
import { AlertType, InlineAlert } from 'district-ui-client/components/inline-alert'
import { TooltipInfo } from 'district-ui-client/components/tooltip'
import { ThemedLinkTo } from 'district-ui-client/components/themed-button'

interface OverCapacityAlertSignature {
  Element: HTMLElement
  Args: {
    schools?: Nullable<School[]>
    subscriptionType: SubscriptionType
  }
}

function schoolIsOverCapacity(school: School, subscriptionType: SubscriptionType): boolean {
  const utilisation = school.utilisationFor(subscriptionType)
  return utilisation?.isOverCapacity ?? false
}

export class OverCapacityAlert extends Component<OverCapacityAlertSignature> {
  get overCapacitySchoolCount() {
    return this.overCapacitySchools.length
  }

  get overCapacitySchools() {
    return this.args.schools?.filter((school) => schoolIsOverCapacity(school, this.args.subscriptionType)) || []
  }

  <template>
    {{#if this.overCapacitySchoolCount}}
      <InlineAlert @type={{AlertType.Warning}} @showClose={{true}} data-test-over-capacity-alert ...attributes>
        <div class="space-y-2">
          <h2 class="m-0 flex items-center gap-1 align-middle text-sm">
            {{t "components.overCapacityAlert.title" schoolCount=this.overCapacitySchoolCount}}
            <TooltipInfo @text={{t "components.overCapacityAlert.tooltip"}} />
          </h2>
          <ul class="list-disc py-3 pl-5">
            {{#each this.overCapacitySchools as |school|}}
              <li>
                <span class="font-semibold">{{school.name}}</span>
              </li>
            {{/each}}
          </ul>
          <p class="m-0 text-sm">{{t "components.overCapacityAlert.schoolsDescription"}}</p>
          <ThemedLinkTo @style="theme" @route="subscription-type.support">
            <span class="flex items-center">{{t "components.overCapacityAlert.contactSupport"}}
              <PhosphorIcon @icon="phosphor-arrow-right" /></span>
          </ThemedLinkTo>
        </div>
      </InlineAlert>
    {{/if}}
  </template>
}

export default OverCapacityAlert
